import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ThanhVienPhanQuyenKhuVuc } from 'src/app/shared/ThanhVienPhanQuyenKhuVuc.model';
import { BaseService } from './Base.service';
@Injectable({
    providedIn: 'root'
})
export class ThanhVienPhanQuyenKhuVucService extends BaseService {

    list: ThanhVienPhanQuyenKhuVuc[] | undefined;
    list001: ThanhVienPhanQuyenKhuVuc[] | undefined;
    formData!: ThanhVienPhanQuyenKhuVuc;

    displayColumns001: string[] = ['STT', 'Display', 'Code', 'Name', 'Active'];

    constructor(public httpClient: HttpClient) {
        super(httpClient);
        this.controller = "ThanhVienPhanQuyenKhuVuc";
    }

    GetSQLByParentIDAndDanhMucTinhThanhIDToListAsync() {
        let url = this.aPIURL + this.controller + '/GetSQLByParentIDAndDanhMucTinhThanhIDToListAsync';
        const formUpload: FormData = new FormData();
        formUpload.append('data', JSON.stringify(this.baseParameter));
        return this.httpClient.post(url, formUpload);
    }
}

